import { render } from "./Lightbox.vue?vue&type=template&id=002f5610"
import script from "./Lightbox.vue?vue&type=script&lang=js"
export * from "./Lightbox.vue?vue&type=script&lang=js"

import "./Lightbox.vue?vue&type=style&index=0&id=002f5610&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__